import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

export const registerUser = async (userData) => {
    const response = await axios.post('https://www.rosscentanni.com/projects/restaurant/api/customers/register', userData);
    return response.data;
};

export const login = async (credentials) => {
    console.log('Payload being sent to backend:', credentials); // Debugging log
    const { email, password } = credentials; // Destructure email and password
    const response = await axios.post('https://www.rosscentanni.com/projects/restaurant/api/auth/admin/login', {
        email, // Send email directly
        password, // Send password directly
    });
    console.log('Backend response:', response); // Debugging log
    return response.data;
};

export const logoutUser = () => {
    delete axios.defaults.headers.common['Authorization'];
    localStorage.removeItem('token');
};

export const resetPassword = async (email) => {
    const response = await axios.post('https://www.rosscentanni.com/projects/restaurant/api/auth/password-reset', { email });
    return response.data;
};

export const getCurrentUser = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
        const decodedToken = jwtDecode(token); // Decode the token
        return { id: decodedToken.id, email: decodedToken.email }; // Return user details
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};

export const setAuthToken = (token) => {
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        localStorage.setItem('token', token);
    } else {
        delete axios.defaults.headers.common['Authorization'];
        localStorage.removeItem('token');
    }
};